export default "__VITE_PUBLIC_ASSET__c2821c22__"